import { Restaurant } from '../../types'
import { BaseEntityService } from '../BaseEntityService'

export class RestaurantEntityService extends BaseEntityService<Restaurant>() {
  static entityPath: string = 'restaurant'
}
